import { FETCH_VM, RESET_VM } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const vmViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VM:
      return { data: action.payload };
    case RESET_VM:
      return initialState;
    default:
      return state;
  }
};

export default vmViewReducer;
